import navigationServiceService from "@/services/navigationServiceService";

const state = () => ({
  all: [],
  single: null
});

const actions = {
  async create({ dispatch }, formData) {
    try {
      const res = await navigationServiceService.create(formData);
      dispatch(
        "common/showSuccess",
        `URL wurde erfolgreich angelegt.`,
        { root: true }
      );
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "URL konnte nicht erstellt werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }) {
    try {
      const res = await navigationServiceService.findAll();
      commit("setAll", res.data);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "URLs konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findOne({ commit, dispatch }, { id }) {
    commit("setSingle", null);
    try {
      const res = await navigationServiceService.findOne({ id });
      commit("setSingle", res.data);
      return Promise.resolve({...res.data});
    } catch (error) {
      dispatch(
        "common/showError",
        "URL konnte nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await navigationServiceService.delete({ id });
      dispatch("findAll");
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "URL konnte nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async update({ dispatch }, formData) {
    try {
      const res = await navigationServiceService.update(formData);
      // dispatch("findAll");
      dispatch(
        "common/showSuccess",
        "URL wurde erfolgreich aktualisiert.",
        { root: true }
      );
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "URL konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  }
};

const getters = {
};

const mutations = {
  setAll(state, object) {
    state.all = object;
  },
  setSingle(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
